import React, { useEffect, useState } from 'react';
import { Card, InputNumber, Button, Typography, App } from 'antd';
import { shopSettingsApi } from '../../services/api';

const { Text } = Typography;

export function SessionSecuritySetting() {
  const { message } = App.useApp();
  const [minutes, setMinutes] = useState<number>(120);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    shopSettingsApi.get().then(({ data }) => {
      const v = (data as any)?.session_idle_timeout_minutes;
      if (typeof v === 'number') setMinutes(v);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await shopSettingsApi.update({ session_idle_timeout_minutes: minutes } as any);
      message.success('Inactivity timeout updated');
    } catch {
      message.error('Could not update timeout');
    } finally { setSaving(false); }
  };

  return (
    <Card size="small" title="Security">
      <Text>Inactivity timeout (minutes)</Text>
      <div style={{ display: 'flex', gap: 8, marginTop: 8, alignItems: 'center' }}>
        <InputNumber min={5} max={1440} value={minutes} onChange={v => setMinutes(Number(v) || 120)} aria-label="Inactivity timeout" />
        <Button type="primary" loading={saving} onClick={save}>Save</Button>
      </div>
      <Text type="secondary" style={{ fontSize: 12 }}>Staff are signed out after this much inactivity. Default 120.</Text>
    </Card>
  );
}
